/* ==========================================================================
   OASIS PREMIUM RECOVERY — Custom JS Bundle
   Externalized from theme.liquid inline scripts
   Load order: after DOM, deferred
   ========================================================================== */


// === Header State Manager (applyHeaderState) ===

(function () {
        // ---- 1) Inject CSS LAST so it wins specificity battles ----
        // CSS moved to oasis-typography.css

        

        // ---- 2) Toggle header state without relying on theme logic ----
        function applyHeaderState() {
          var header = document.querySelector('.shopify-section-header');
          if (!header) return;
          var isSticky = header.classList.contains('shopify-section-header-sticky');
          var isHome = header.getAttribute('data-page-type') === 'index';
          if (isHome && !isSticky) {
            header.classList.add('oasis-top');
            header.classList.remove('oasis-scrolled');
          } else {
            header.classList.remove('oasis-top');
            header.classList.add('oasis-scrolled');
          }
        }
        document.addEventListener('scroll', applyHeaderState, { passive: true });
        document.addEventListener('DOMContentLoaded', applyHeaderState);
        window.addEventListener('load', applyHeaderState);
        document.addEventListener('shopify:section:load', applyHeaderState);

        // ---- 3) Remove the placeholder message by text content ----
        var killText = 'Oasis homepage placeholder — replace me in Customize.';
        function removePlaceholder() {
          var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
          var nodes = [];
          while (walker.nextNode()) {
            var n = walker.currentNode;
            if (n.nodeValue && n.nodeValue.indexOf(killText) > -1) nodes.push(n);
          }
          nodes.forEach(function (n) {
            if (n.parentElement) n.parentElement.style.display = 'none';
          });
        }
        document.addEventListener('DOMContentLoaded', removePlaceholder);
        window.addEventListener('load', removePlaceholder);
      })();



// === Homepage: Header scroll + contact overlay behavior ===

document.addEventListener('DOMContentLoaded', function () {
        // Run only on homepage
        if (window.location.pathname === '/') {
          const overlay = document.querySelector('.hero-contact-overlay');
          if (!overlay) return; // Prevent errors if overlay not found
          const offsetTop = overlay.offsetTop;

          const links = document.querySelectorAll('.custom-contact-div a');
          const svgs = document.querySelectorAll('.custom-contact-div svg, .icon-hamburger');

          const header = document.querySelector('.header');
          const logoElement = document.querySelector('.logo-show-scroll');

          // Set initial state (on top)
          links.forEach((link) => (link.style.color = 'white'));
          svgs.forEach((svg) => {
            svg.style.color = 'white';
            svg.style.fill = 'white';
            svg.style.stroke = 'white';
          });
          header.style.setProperty('background', 'transparent', 'important');
          header.style.setProperty('color', '#ffffff', 'important');
          if (logoElement) logoElement.style.setProperty('display', 'none', 'important');

          window.addEventListener('scroll', function () {
            if (window.scrollY > offsetTop) {
              // Sticky overlay
              overlay.classList.add('sticky');

              links.forEach((link) => (link.style.color = '#C9A85F'));
              svgs.forEach((svg) => {
                svg.style.color = '#C9A85F';
                svg.style.fill = '#C9A85F';
                svg.style.stroke = '#C9A85F';
              });
            } else {
              overlay.classList.remove('sticky');

              links.forEach((link) => (link.style.color = 'white'));
              svgs.forEach((svg) => {
                svg.style.color = 'white';
                svg.style.fill = 'white';
                svg.style.stroke = 'white';
              });
            }

            // Header + logo scroll effect
            if (window.scrollY > 0) {
              header.style.setProperty('background', '#f7f7f3', 'important');
              header.style.setProperty('color', '#dbbf8b', 'important');
              if (logoElement) logoElement.style.setProperty('display', 'block', 'important');
            } else {
              header.style.setProperty('background', 'transparent', 'important');
              header.style.setProperty('color', '#ffffff', 'important');
              if (logoElement) logoElement.style.setProperty('display', 'none', 'important');
            }
          });
        }
      });



// === Header margin adjustment (mobile) ===

document.addEventListener('DOMContentLoaded', function () {
        const header = document.querySelector('.header') || document.querySelector('header');

        function updateHeaderMargin() {
          if (!header) return;
          if (window.innerWidth <= 768) {
            // mobile only
            if (window.scrollY === 0) {
              header.style.marginTop = '0px';
            } else {
              header.style.marginTop = '35px';
            }
          } else {
            // reset for desktop
            header.style.marginTop = '';
          }
        }

        // Run on scroll + load
        window.addEventListener('scroll', updateHeaderMargin);
        window.addEventListener('resize', updateHeaderMargin);
        updateHeaderMargin();
      });



// === Brochure request modal logic ===

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var urlParams    = new URLSearchParams(window.location.search);
    var modal        = document.getElementById('oasis-modal');
    var formContent  = document.getElementById('modal-content-form');
    var successContent = document.getElementById('modal-content-success');
    var brochureForm = document.getElementById('brochure-form');
    var validateBtn  = document.getElementById('btn-validate-trigger');
    var errorDiv     = document.getElementById('oasis-error-message');
    var openBtns     = document.querySelectorAll('a[href="#start-journey"]');

    // ── Toggle textarea ────────────────────────────────────
    var msgOpen = false;
    var toggleBtn   = document.getElementById('oasis-msg-toggle-btn');
    var toggleIcon  = document.getElementById('oasis-msg-toggle-icon');
    var toggleLabel = document.getElementById('oasis-msg-toggle-label');
    var msgArea     = document.getElementById('oasis-msg-area');

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        msgOpen = !msgOpen;
        msgArea.style.display     = msgOpen ? 'block' : 'none';
        toggleIcon.style.transform = msgOpen ? 'rotate(90deg)' : 'rotate(0deg)';
        toggleLabel.textContent   = msgOpen ? 'Remove message' : 'Add a message (optional)';
        toggleBtn.setAttribute('aria-expanded', String(msgOpen));
      });
    }

    // ── Mostrar modal ──────────────────────────────────────
    function resetFieldBorders() {
      ['modal-email', 'modal-phone'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.style.borderColor = '#e1e1e1';
      });
    }

    function showOasisModal(state) {
      if (!modal) return;
      modal.style.display = 'flex';
      if (errorDiv) errorDiv.style.setProperty('display', 'none', 'important');
      resetFieldBorders();

      if (state === 'success') {
        formContent.style.display    = 'none';
        successContent.style.display = 'block';
      } else {
        formContent.style.display    = 'block';
        successContent.style.display = 'none';
      }
    }

    // Auto-abrir tras redirect de Shopify
    if (urlParams.has('customer_posted')) showOasisModal('success');

    // Botones de apertura en página
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var alreadySent = sessionStorage.getItem('oasis_request_sent') === 'true';
        showOasisModal(alreadySent ? 'success' : 'form');
      });
    });

    // Cerrar con clic en overlay
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.style.display = 'none';
    });

    // ── Validación + Envío ─────────────────────────────────
    if (validateBtn && brochureForm) {
      validateBtn.addEventListener('click', function () {
        var emailVal = document.getElementById('modal-email').value.trim();
        var phoneVal = document.getElementById('modal-phone').value.trim();

        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        var phoneRegex = /^\+?[\d\s\-]{9,18}$/;

        var msg = '';
        if (!emailRegex.test(emailVal)) {
          msg = 'Please enter a valid email (e.g. name@domain.com)';
        } else if (!phoneRegex.test(phoneVal)) {
          msg = 'Please enter a valid phone number (min. 9 digits)';
        }

        if (msg !== '') {
          errorDiv.textContent = msg;
          errorDiv.style.setProperty('display', 'block', 'important');
          document.getElementById('modal-email').style.borderColor = !emailRegex.test(emailVal) ? '#d9534f' : '#e1e1e1';
          document.getElementById('modal-phone').style.borderColor = !phoneRegex.test(phoneVal) ? '#d9534f' : '#e1e1e1';
          return;
        }

        // Construir note con contexto UTM
        var params   = new URLSearchParams(window.location.search);
        var msgVal   = (document.getElementById('modal-message') || {}).value || '';
        var noteData = [
          'Request Type: brochure_request',
          'Lead Phone: '   + phoneVal,
          'Message: '      + (msgVal || 'none'),
          'Landing: '      + window.location.pathname,
          'Referrer: '     + (document.referrer || 'direct'),
          'UTM Source: '   + (params.get('utm_source')   || 'none'),
          'UTM Medium: '   + (params.get('utm_medium')   || 'none'),
          'UTM Campaign: ' + (params.get('utm_campaign') || 'none'),
          'Submitted At: ' + new Date().toISOString()
        ].join(' | ');

        var noteInput = document.getElementById('modal-lead-note');
        if (noteInput) noteInput.value = noteData;

        sessionStorage.setItem('oasis_request_sent', 'true');
        brochureForm.submit();
      });
    }
  });
})();



// === Eyebrow text injector (MutationObserver) ===

(function () {
        const observer = new MutationObserver((mutations, obs) => {
          // Buscamos la clase específica
          const targetHeading = document.querySelector('[class*="ai-hero-video__heading-"]');

          if (targetHeading && !document.querySelector('.oasis-injected-eyebrow')) {
            const eyebrow = document.createElement('p');
            eyebrow.className = 'oasis-injected-eyebrow';
            eyebrow.innerText = 'RECLAIM YOUR LIFE IN PRIVATE, SAFE SANCTUARY';

            // Estilo adaptado para convivir con Page Builders
            eyebrow.style.cssText = `
          display: block;
          font-size: clamp(12px, 1.2vw, 14px) !important;
          letter-spacing: 0.3em !important;
          text-transform: uppercase !important;
          color: #FFFFFF !important;
          opacity: 0.8 !important;
          margin-bottom: 15px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          text-align: inherit !important;
        `;

            targetHeading.parentNode.insertBefore(eyebrow, targetHeading);
            obs.disconnect(); // Una vez lo pone, deja de vigilar
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      })();



// === Menu drawer: hide contact div when open ===

(function () {
        'use strict';

        function toggleContactDiv(isMenuOpen) {
          const contactDiv = document.querySelector('.custom-contact-div');

          if (!contactDiv) return;

          contactDiv.style.display = isMenuOpen ? 'none' : '';
        }

        const menuDrawer = document.querySelector('.menu-drawer');

        if (menuDrawer) {
          const observer = new MutationObserver(() => {
            const isOpen = menuDrawer.hasAttribute('open');
            toggleContactDiv(isOpen);
          });

          observer.observe(menuDrawer, {
            attributes: true,
            attributeFilter: ['open'],
          });
        }
      })();



// === Form submissions → Google Apps Script (Sheets) ===

document.addEventListener('submit', function(e) {
          const form = e.target;
          if (!form || form.tagName !== 'FORM') return;

          const formData = new FormData(form);
          let data = {};
          formData.forEach((val, key) => { data[key] = val; });

          const payload = {
              firstName: data['contact[first_name]'] || data['contact[name]'] || '',
              lastName:  data['contact[last_name]'] || '',
              email:     data['contact[email]'] || '',
              phone:     data['contact[phone]'] || '',
              message:   data['contact[body]'] || data.Message || '',
              url:       window.location.href,
              id:        Date.now(),
              formType:  form.id || window.location.pathname
          };

          console.log('Datos capturados del form:', data);
          console.log('Payload preparado para Apps Script:', payload);

          // Envía a Apps Script con sendBeacon
          const blob = new Blob([JSON.stringify(payload)], {type: 'text/plain'});
          const beaconSent = navigator.sendBeacon(
              'https://script.google.com/macros/s/AKfycbxRSHOYwKOxrD3a8lIXh3r7QTpATukcegB4lXYTE6nPb8y9ERNcEstQ7_F6eHZQIjgB/exec',
              blob
          );
          console.log('Beacon enviado:', beaconSent);

          // No bloquea el submit a Shopify
      });



// === Auto alt text generator for images ===

document.addEventListener('DOMContentLoaded', function() {
        const brandName = 'Oasis Premium Recovery';
        const EXCLUDE_SMALL = { width: 60, height: 80 };

        function generateAltText(img) {
          if (!img || img.dataset.altAdded) return;

          let filename = (img.src || img.dataset.src || '')
                          .split('/').pop().split('.')[0]
                          .replace(/screenshot|screen/gi, '')
                          .replace(/\d+/g, '')
                          .replace(/[-_]/g, ' ')
                          .trim();

          let detail = filename ? filename.charAt(0).toUpperCase() + filename.slice(1) : 'Imagen';
          detail = detail.replace(/\b(img|image|foto|pic|wp|banner|bg|icon)\b/gi, '').trim();

          let pageContext = document.title.split(/[\|\-]/)[0].trim();
          if (!pageContext || pageContext.length < 3) {
            pageContext = document.body.closest('.page')?.querySelector('h1')?.textContent?.trim().substring(0, 30)
                          || document.querySelector('h1, .page-title')?.textContent?.trim().substring(0, 30)
                          || 'Página Oasis';
          }

          let altText = (detail !== 'Imagen' && detail.length > 2) ? 
                        `${brandName} - ${detail} - ${pageContext}` : 
                        `${brandName} - ${pageContext}`;

          if ((img.naturalWidth < EXCLUDE_SMALL.width || img.width < EXCLUDE_SMALL.width) && img.height < EXCLUDE_SMALL.height) {
            altText = '';
          }

          img.alt = altText;
          img.dataset.altAdded = 'true';
          img.loading = 'lazy';

          console.log(`✅ Alt added: "${altText.substring(0,50)}..." → ${img.src?.split('/').pop() || img.dataset.src}`);
        }

        // 1️⃣ Procesa todas las imágenes ya cargadas
        document.querySelectorAll('img').forEach(generateAltText);

        // 2️⃣ Observa cambios en el DOM y lazy load
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType !== 1) return;
              if (node.tagName === 'IMG') generateAltText(node);
              else node.querySelectorAll('img').forEach(generateAltText);
            });

            if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
              generateAltText(mutation.target);
            }
          });
        });

        observer.observe(document.body, { 
          childList: true, 
          subtree: true, 
          attributes: true, 
          attributeFilter: ['src'] 
        });

        // 3️⃣ Interval fallback: revisa cada 2s imágenes sin alt
        setInterval(() => {
          document.querySelectorAll('img:not([data-alt-added])').forEach(generateAltText);
        }, 2000);
      });

